import axios from 'axios';
import { history } from './state/store';

export default {
    setup() {
        axios.interceptors.response.use(
            response => {
                return response;
            },
            function(error) {
                let originalRequest = error.config;

                if (
                    error.response &&
                    error.response.status === 401 &&
                    !originalRequest._retry &&
                    !window.location.href.endsWith('signin')
                ) {
                    history.push('/account/signin');
                    return;
                }

                return Promise.reject(error);
            }
        );
    },
};
